import React from "react";
import { PeekTypography } from "@piiqtechnologies/ui-components";
import { PageHeaderSelect } from "./PageHeaderSelect";
export const PageHeaderOrg = ({ options, value, onChange }) => {
    if (options.length === 0)
        return null;
    if (options.length === 1) {
        return (React.createElement(PeekTypography, { sx: { fontSize: "32px", lineHeight: "25px", fontWeight: 200 } }, options[0].label));
    }
    return React.createElement(PageHeaderSelect, { reports: { options, value, onChange } });
};
export default PageHeaderOrg;
